export const MAX_ITEMS_LIMIT = 800;